import vSelect from "./v-select.vue";
import vOption from "./v-option.vue";

export default Vue => {
  Vue.component("v-select", vSelect);
  Vue.component("v-option", vOption);
};
